import { ComplianceEntity } from "@wingspanhq/wingspan-api-sdk";
import { FormPartialDataUsPersonInfo } from "../components/FormPartialUsPersonInfo";

/**
 * Prefills the US-person step from what v3 stores.
 *
 * The step writes its names onto the entity's individual legal name, so those come
 * back. The SSN reads back as a has-value flag only, and the date the person became
 * a US person has no field on the entity — so the "when" answer falls back to the
 * form's default instead of the stored date.
 */
export const selectorUsPersonPartialFormData = (
  entity: ComplianceEntity | undefined
): Partial<FormPartialDataUsPersonInfo> => ({
  firstName: entity?.individualLegalName?.givenName,
  middleName: entity?.individualLegalName?.middleNames,
  lastName: entity?.individualLegalName?.familyName
});
